import { styled } from '../../../stitches.config';

/**
 * A bay with no module in it, drawn as the outline of the 24×20 port art with the ring dashed and
 * the body left out.
 */
export const SlotEmptyBay = styled('div', {
  width: '$24',
  height: '$20',
  border: '1px dashed currentColor',
  borderRadius: '$4',
});
SlotEmptyBay.displayName = 'SlotEmptyBay';
